import { CheckCircleFilled, EditOutlined } from '@ant-design/icons';
import { Alert, Button, Empty, Skeleton, Tag, Typography } from 'antd';
import { useState } from 'react';

export default function PlanSelectionStep({
  copy,
  error,
  loading,
  onRetry,
  onSelect,
  plans,
  selectedPlan,
}) {
  const [showCatalog, setShowCatalog] = useState(!selectedPlan);

  if (loading) return <Skeleton active paragraph={{ rows: 6 }} />;

  if (error) {
    return (
      <Alert
        showIcon
        type="error"
        message={copy.loadError}
        description={error}
        action={<Button onClick={onRetry}>{copy.retry}</Button>}
      />
    );
  }

  if (!plans.length) return <Empty description={copy.empty} />;

  return (
    <>
      {selectedPlan && !showCatalog ? (
        <article className="onboarding-selected-plan">
          <div className="onboarding-selected-plan-main">
            <span className="onboarding-selected-plan-icon"><CheckCircleFilled /></span>
            <div>
              <Typography.Text type="secondary">Selected plan</Typography.Text>
              <Typography.Title level={4}>{selectedPlan.title}</Typography.Title>
              <Typography.Paragraph type="secondary">{selectedPlan.description}</Typography.Paragraph>
            </div>
          </div>
          <div className="onboarding-selected-plan-price">
            <span>Plan price</span>
            <strong>{selectedPlan.pricing?.pricingLabel}</strong>
          </div>
          <Button icon={<EditOutlined />} onClick={() => setShowCatalog(true)}>Change plan</Button>
        </article>
      ) : (
      <div className="onboarding-plan-grid">
        {plans.map((plan) => {
        const selected = selectedPlan?.id === plan.id;
        const features = [...(plan.features || [])]
          .sort((left, right) => left.sortOrder - right.sortOrder);

        return (
          <article
            className={`onboarding-plan-option${selected ? ' onboarding-plan-option--selected' : ''}`}
            key={plan.id}
          >
            {plan.badgeText ? <Tag color="blue" className="onboarding-plan-featured-tag">{plan.badgeText}</Tag> : null}

            <div className="onboarding-plan-option-header">
              <div>
                <Typography.Text type="secondary">
                  {plan.shortLabel}
                </Typography.Text>
                <Typography.Title level={4}>{plan.title}</Typography.Title>
              </div>
              {selected ? <CheckCircleFilled className="onboarding-plan-check" /> : null}
            </div>

            <Typography.Paragraph type="secondary">
              {plan.description}
            </Typography.Paragraph>

            {plan.pricing?.pricingLabel ? (
              <div className="onboarding-plan-price">
                <strong>{plan.pricing.pricingLabel}</strong>
                {plan.pricing.description ? <span>{plan.pricing.description}</span> : null}
                {plan.pricing.badgeText ? <Tag>{plan.pricing.badgeText}</Tag> : null}
              </div>
            ) : null}

            <ul className="onboarding-plan-features">
              {features.map((feature) => (
                <li key={feature.id}>{feature.description}</li>
              ))}
            </ul>

            <Button
              block
              type={selected ? 'default' : 'primary'}
              disabled={plan.purchasable === false}
              onClick={() => { onSelect(plan); setShowCatalog(false); }}
            >
              {plan.purchasable === false
                ? copy.contactSales
                : selected
                  ? copy.selected
                  : copy.select}
            </Button>
          </article>
        );
        })}
      </div>
      )}
    </>
  );
}
